/**
 * This cache takes a key and saves an object. If you instantiate a cache for each component you need one for,
 * all items of this cache will be dereferences once your component is unmounted
 */
class SimpleCache {

  constructor () {
    this.cache = {}
  }

  getIcon (key) {
    return this.cache[key]
  }

  setIcon (key, icon) {
    this.cache[key] = icon
    return icon
  }

}

export default SimpleCache



// WEBPACK FOOTER //
// ./src/utils/SimpleCache.js